<template>
    <div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('incomingDoc.host')}}/Port:</label>
            <div class="col-6">
                <input type="text" v-model="value.Host" class="form-control" required maxlength="300" />
            </div>
            <div class="col-3">
                <input type="number" v-model="value.Port"  class="form-control" required min="1" max="65536" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('incomingDoc.username')}}</label>
            <div class="col">
                <input v-model="value.Credential.Username" type="text" class="form-control" required  @change="$forceUpdate()" />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('incomingDoc.passcode')}}</label>
            <div class="col">
                <password v-model="value.Credential.Password" class="form-control" required @change="$forceUpdate()" />
            </div>
        </div>

        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('incomingDoc.fingerprint')}}</label>
            <div class="col">
                <input v-model="value.SshHostKeyFingerprint" type="text" class="form-control" required />
            </div>
        </div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('incomingDoc.uzakDizin')}}</label>
            <div class="col">
                <div class="input-group mb-3">
                    <input v-model="value.Path" type="text" class="form-control" required />
                    <div class="input-group-append">
                        <button type="button" class="btn btn-secondary" @click="$emit('ftpLookupTargetSystem')">
                            {{translate('lookup')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <div class="col col-sm-3"></div>
            <div class="col">
                <label>
                    <input type="checkbox" v-model="value.SlugifyFileName" />
                    {{translate('targetSystem.fileSystem.slugifyFileName')}}
                    <small class="d-block text-muted">{{translate('targetSystem.fileSystem.slugifyFileNameSubtext')}}</small> 
                </label>         
            </div>
        </div>
        <div class="form-group row">
            <div class="col col-sm-3"></div>
            <div class="col">
                <label>
                    <input type="checkbox" v-model="value.PrependIdToFileName" />
                    {{translate('targetSystem.fileSystem.PrependIdToFileName')}}
                    <small class="d-block text-muted">{{translate('targetSystem.fileSystem.PrependIdToFileNameSubtext')}}</small>
                </label>        
                
            </div>
        </div>
        
        <div class="form-group row">
            <div class="col col-sm-3"></div>
            <div class="col">
                <label for="DropFilesUnderUniqueDirectory">{{translate('targetSystem.fileSystem.DropFilesUnderUniqueDirectory')}}:</label>
                <select name="DropFilesUnderUniqueDirectory" id="DropFilesUnderUniqueDirectory" class="form-control" v-model="value.DropFilesUnderUniqueDirectory">
                    <option value=""></option>
                    <option value="JobId">{{translate('targetSystem.fileSystem.DropFilesUnderUniqueDirectoryOptions.jobId')}}</option>
                    <option value="DocumentNo">{{translate('targetSystem.fileSystem.DropFilesUnderUniqueDirectoryOptions.documentNo')}}</option>
                    <option value="TrackingNo">{{translate('targetSystem.fileSystem.DropFilesUnderUniqueDirectoryOptions.trackingNo')}}</option>
                </select>
                 <small class="d-block text-muted">{{translate('targetSystem.fileSystem.DropFilesUnderUniqueDirectorySubtext')}}</small>
            </div>
           
        </div>

        <div class="form-group row">
            <div class="col col-sm-3"></div>
            <div class="col">
                <label>
                    <input type="checkbox" v-model="value.EnableSSL" />
                    {{translate('targetSystem.ftp.sslEnabled')}}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import password from '@/components/Password.vue'

export default {
    components: {
        password
    },
    props: ['value'],
    data(){
        return {

        }
    },
    methods: {

    }
}

</script>
